export var componentsLocales = {
  prefix: 'k',
  suffix: 'ntur'
};